import React, { Component } from "react";

import mixpanel from "mixpanel-browser";
import axios from "axios";
import { Button, Alert } from "react-bootstrap";

import {CardElement} from 'react-stripe-elements';

import '../content/content.css';

import {injectStripe} from 'react-stripe-elements';

class StripeForm extends Component {

	constructor() {
		super();

		this.renderCardDetailsForm = this.renderCardDetailsForm.bind(this);
		this.renderRemoveCardDetails = this.renderRemoveCardDetails.bind(this);
		this.renderPoweredByStripe = this.renderPoweredByStripe.bind(this);

		this.handleGetCard = this.handleGetCard.bind(this);
		this.handleAddCard = this.handleAddCard.bind(this);		
		this.handleRemoveCard = this.handleRemoveCard.bind(this);

		this.state = { cardPresent : undefined, status: null };

		this.mixpanel = mixpanel;
	}

	componentDidMount() {
		this.handleGetCard();
	}

  handleSubmit = (ev) => {
  	this.setState({status: 'submitting'});

    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.

    //TODO improve: collect name and address to improve security
    let that = this;
    this.props.stripe.createToken({type: 'card'})
    .then(function(result) {
    	if (result.error) {
    		that.mixpanel.track("Stripe Token Creation Failed", { success: false, error: result.error });
    		that.setState({'status' : 'error', 'errorMessage' : result.error.message });
    	} else if (result.token) {
    		that.mixpanel.track("Stripe Token Created");
    		that.handleAddCard(result.token);
    	} else {
    		that.mixpanel.track("Stripe Token Creation Failed - unknown state");
    		that.setState({'status' : 'error'});
    	}
    });
  }

  handleAddCard(token) {
  		const tokenData = { token: token.id };  		
        let that = this;
        this.setState({status: 'submitting'});
        axios
            .post("/api/cards", tokenData)
            .then(function(response) {
                that.setState({ status: 'success', cardPresent: true });
                that.mixpanel.track("Add Card", {
                    success: true
                });

            })
            .catch(function(error) {            	
                that.mixpanel.track("Add Card Failed", {
                    success: false,
                    error: error
                });
                that.setState({ status: 'error' });
        });
  }

  handleGetCard(token) {  		
        let that = this;
        axios
            .get("/api/cards")
            .then(function(response) {            	
                that.setState({ cardPresent: response.data.cardPresent });
            })
            .catch(function(error) {            	
                that.mixpanel.track("Get Card Failed", {
                    success: false,
                    error: error
                });
                that.setState({ status: 'error' });
        });        
  }  

  handleRemoveCard() {
  	if (this.state.status !== 'submitting') {
        let that = this;
        this.setState({status: 'submitting'});
        axios
            .delete("/api/cards")
            .then(function(response) {
                that.setState({ status: 'success', cardPresent: false });
                that.mixpanel.track("Remove Card", {
                    success: true
                });
            })
            .catch(function(error) {            	
                that.mixpanel.track("Remove Card Failed", {
                    success: false,
                    error: error
                });
                that.setState({ status: 'error' });
        });
    }    
  }

  renderPoweredByStripe() {
  	return <img alt="Payments powered by Stripe" src={process.env.PUBLIC_URL + '/poweredbystripe.png'} width="280" height="42" style={{opacity: 0.7, margin: 0}} />
  }

  renderCardDetailsForm() {
    return (
      <form onSubmit={this.handleSubmit}>
      	{this.state.status === 'error' && <Alert bsStyle="danger" style={{marginBottom: 0}}>{this.state.errorMessage}</Alert>}
        <div style={{maxWidth: '500px', margin: '0 auto', padding: '20px', background: 'rgba(242, 121, 176, 0.25)', borderRadius: '4px'}}>        	
    		<CardElement style={{base: {fontSize: '14px'}}} />
  		</div>
  		<div style={{margin: '30px'}}>
			<Button type="submit" disabled={this.state.status === 'submitting'}>Add card{this.submitEllipsis()}</Button>
		</div>
  		<div>
  			{this.renderPoweredByStripe()}
  		</div>		
      </form>
    );
  }

  renderRemoveCardDetails() {
  	return (
  		<div>
	  		<div style={{margin: '30px'}}>
	  			<i className="fa fa-check-circle-o fa-3x"></i>
	  			<h5><strong>Card Present</strong></h5>
	  			<div><small><a className="clickable" onClick={this.handleRemoveCard} disabled={this.state.status === 'submitting'}>Remove Card{this.submitEllipsis()}</a></small></div>
	  		</div>
	  		<div>
	  			<p>You can remove your card details any time. <br /> But if you do, you will loose the 30% lifetime discount for Webfinery Search.</p>	  			
	  		</div>
	  		<div>
	  			{this.renderPoweredByStripe()}
	  		</div>	  			
	  	</div>
  	)
  }

  renderPlaceholder() {
  	return (
  		<div style={{margin: '30px'}}>
  			<i className="fa fa-2x fa-refresh fa-spin"></i>
  		</div>
  	);
  }

  submitEllipsis() {
  	return this.state.status === 'submitting' ? '...' : '';
  }

  render() {
  	if (this.state.cardPresent === true) {
  		return this.renderRemoveCardDetails();
  	} else if (this.state.cardPresent === false) {
  		return this.renderCardDetailsForm();
  	} else {
  		return this.renderPlaceholder();
  	}
  }
}

export default injectStripe(StripeForm);



// WEBPACK FOOTER //
// ./src/stripe/StripeForm.js